import React from "react";

interface IconWrapperProps {
  icon: any;
  size?: number;
  color?: string;
  className?: string;
}

const IconWrapper: React.FC<IconWrapperProps> = ({
  icon: Icon,
  size,
  color,
  className,
}) => {
  return <Icon size={size} color={color} className={className} />;
};

export default IconWrapper;
